// diagnosticsPack — B-1b (F5): pełny pakiet diagnostyczny TEGO urządzenia (ten sam kształt,
// co „Wyślij diagnostykę do centrali" w Serwisie): kolejka bez blobów, rejestr „Utracone",
// rejestr prób wysyłki, statystyki, meta (wersje, sieć, Tryb lokalny, ostatni sukces, UA).
// Używany przez automatyczne wyzwalacze (fleet.js) — Serwis buduje swój pakiet ze świeżego
// stanu ekranu (SupportScreen.buildDiagnostics), oba trafiają do POST /api/fleet/diagnostics.

import { getPhotoQueue, getQueueStats, getLostRegistry, getUploadLog } from './offlineDB.js';
import { toSafeEntry, toLostEntry, toUploadLogEntry, fetchSwInfo } from '../components/supportDiagnostics.js';
import { isLocalMode } from './localMode.js';
import { getLastSuccessAt } from './queueHealth.js';
import { getNetState, readNetworkInfo } from './netActivity.js';
import { APP_VERSION } from '../shared/appVersion.js';

/**
 * @param {{ swInfo?: object|null, extra?: object }} [opts]
 * @returns {Promise<{queue:Array, lost:Array, uploadLog:Array, stats:object, meta:object}>}
 */
export async function buildDiagnosticsPack({ swInfo = undefined, extra = {} } = {}) {
  const [queue, stats, lost, uploadLog, sw] = await Promise.all([
    getPhotoQueue().catch(() => []),
    getQueueStats().catch(() => ({ total: 0, pending: 0, uploading: 0, failed: 0, bytes: 0 })),
    getLostRegistry().catch(() => []),
    getUploadLog(30).catch(() => []),
    swInfo === undefined ? fetchSwInfo().catch(() => null) : Promise.resolve(swInfo),
  ]);
  const lastSuccessAt = getLastSuccessAt();
  return {
    queue: queue.map(toSafeEntry),
    lost: lost.map(toLostEntry),
    uploadLog: uploadLog.map(toUploadLogEntry),
    stats,
    meta: {
      appVersion: APP_VERSION,
      swVersion: sw?.version || 'nieznana',
      swPrecached: sw?.precached ?? null,
      swPrecacheExpected: sw?.expected ?? null,
      localMode: !!isLocalMode(),
      lastUploadSuccessAt: lastSuccessAt ? new Date(lastSuccessAt).toISOString() : null,
      netState: getNetState(),
      connection: readNetworkInfo(),
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
      online: typeof navigator !== 'undefined' ? navigator.onLine !== false : null,
      clientTime: new Date().toISOString(),
      ...extra,
    },
  };
}
